import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  createstudent,
  getstudent,
  deletestudents,
} from "../../ReduxToolkit/Slice/Student/Student";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Button from "../../components/Button/Button";
import PageTitle from "../../components/Title/PageTitle";
import Input from "../../components/Input/Input";
import Table from "../../components/Table/Table";

function Student() {
  const dispatch = useDispatch();
  const closeButtonRef = useRef(null);
  const { status, students } = useSelector(
    (state) => state.student
  );
  console.log(students.data)
  const [title, setTitle] = useState("");
  const [pdf, setPdf] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = new FormData();
    data.append("title", title);
    data.append("Pdf", pdf);
    try {
      closeButtonRef.current.click();
      dispatch(createstudent(data));
      setTitle("");
      setPdf(null);
    } catch (error) {
      toast.error("Something went wrong");
    }
  };

  useEffect(() => {
    if (status === "idle") {
      dispatch(getstudent());
    }
  }, [dispatch, status]);
  // delete api
  const handleDelete = (studentid) => {
    const Isconfirmed = window.confirm(
      "Are you sure! you want delete this Pdf ?"
    );
    if (Isconfirmed) {
      dispatch(deletestudents(studentid));
    }
  };
  function formatDate(dateString) {
    const options = { year: "numeric", month: "short", day: "numeric" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  }
  const columns = [
    { label: "S.no", accessor: "serialNumber" },
    { label: "Title", accessor: "title" },
    { label: "Date", accessor: "createdAt", formatter: formatDate },
  ];
  return (
    <>
      <div>
        <ToastContainer />
        <div className="d-flex justify-content-between my-3">
          <PageTitle children={"Students study material"} />
          <Button
            data-bs-toggle="modal"
            data-bs-target="#exampleModal"
            children={"Study Material"}
            icon="plus-circle-fill"
          />
        </div>
        <Table
          columns={columns}
          data={students.data || []}
          status={status}
          onDelete={handleDelete}
        />
      </div>

      {/* Modal  */}
      <div
        className="modal fade"
        id="exampleModal"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                Modal title
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <form action="" onSubmit={handleSubmit}>
                <Input
                  label="Title"
                  type="text"
                  value={title}
                  required
                  onChange={(e) => setTitle(e.target.value)}
                  placeholder="Enter the title of the material"
                />
                <Input
                  label="Select Pdf"
                  type="file"
                  required
                  onChange={(e) => setPdf(e.target.files[0])}
                />
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-bs-dismiss="modal"
                    ref={closeButtonRef}
                  >
                    Close
                  </button>
                  <Button type="submit" children={"Upload"} />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Student;
